import React, { useState } from 'react';

const responseOptions = [
  'What is your name?',
  'What is your email address?',
  'What is your calling phone number?',
  'What is your job title?',
  'Which product/service are you interested in?',
  'How did you hear about us?',
  'What is your company name?',
];

const traitOptions = [
  'Name', 'Email', 'age', 'WhatsApp Opted', 'Company Name', 'Company Website'
];

const lists = [
  { name: 'interactive_list', items: ['Ratings', 'Feedback', 'Suggestions'] },
  { name: 'Ratings', items: ['1 Star', '2 Stars', '3 Stars'] },
  { name: 'test', items: ['Test 1', 'Test 2'] },
  { name: 'Shopify features', items: ['Cart', 'Product', 'Discount'] },
];

const CreateWorkflowPage = () => {
  const [workflowTitle, setWorkflowTitle] = useState('Hello i need information');
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [responses, setResponses] = useState([{ id: 1, question: '', trait: '', selectedList: null }]);
  const [selectedList, setSelectedList] = useState(null);
  const [showListModal, setShowListModal] = useState(false);
  const [activeList, setActiveList] = useState(null);

  const handleAddResponse = () => {
    setResponses([...responses, { id: responses.length + 1, question: '', trait: '', selectedList: null }]);
  };

  const handleSaveResponse = (index, key, value) => {
    const newResponses = [...responses];
    newResponses[index][key] = value;
    setResponses(newResponses);
  };

  const handleSelectList = (list) => {
    setActiveList(list);
  };

  const confirmSelectList = (index) => {
    handleSaveResponse(index, 'selectedList', activeList);
    setShowListModal(false);
  };

  return (
    <div style={{ display: 'flex', height: '100vh', fontFamily: 'sans-serif' }}>
      
      {/* Left Sidebar */}
      <div style={{ width: '250px', backgroundColor: '#f9f9f9', borderRight: '1px solid #ddd', padding: '10px' }}>
        <div style={{ marginBottom: '20px', cursor: 'pointer', color: '#2e7d32' }}>← Back to main page</div>
        <h4>All Templates</h4>
        {['Lead Gen - Agency', 'Vehicle Insurance renewal', 'Capture a Testimonial'].map((t, i) => (
          <div key={i} style={{ padding: '6px 0', borderBottom: '1px solid #eee' }}>{t}</div>
        ))}
        <div style={{ marginTop: 'auto', color: '#888' }}>Help</div>
      </div>

      {/* Center Preview */}
      <div style={{ flex: 1, backgroundColor: '#f1f7f3', padding: '30px' }}>
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', border: '1px solid #ccc' }}>
          <h2
            onClick={() => setIsEditingTitle(true)}
            style={{ cursor: 'pointer', color: '#2e7d32', marginBottom: '15px' }}
          >
            {isEditingTitle ? (
              <input
                value={workflowTitle}
                onChange={(e) => setWorkflowTitle(e.target.value)}
                onBlur={() => setIsEditingTitle(false)}
                autoFocus
              />
            ) : (
              `${workflowTitle} ✏️`
            )}
          </h2>
          {responses.map((resp, i) => (
            <div key={i} style={{ marginBottom: '20px', backgroundColor: '#e8f5e9', padding: '10px', borderRadius: '5px' }}>
              <strong>Response {resp.id}</strong>
              <p>{resp.question || 'No question selected'}</p>
              <div style={{ background: '#fff', padding: '10px', borderRadius: '5px', color: '#555' }}>
                &lt;User input&gt;
              </div>
              {resp.selectedList && (
                <div style={{ marginTop: '10px', backgroundColor: '#fafafa', padding: '10px', border: '1px dashed #ccc' }}>
                  <strong>Selected List:</strong> {resp.selectedList.name}
                  <ul>
                    {resp.selectedList.items.map((item, idx) => <li key={idx}>{item}</li>)}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Right Panel */}
      <div style={{ width: '300px', backgroundColor: '#fff', borderLeft: '1px solid #ddd', padding: '20px' }}>
        {responses.map((resp, i) => (
          <div key={i} style={{ marginBottom: '40px' }}>
            <h3>Response {resp.id}</h3>
            <select
              value={resp.question}
              onChange={(e) => handleSaveResponse(i, 'question', e.target.value)}
              style={{ width: '100%', marginBottom: '10px', padding: '8px' }}
            >
              <option value="">Select a response</option>
              {responseOptions.map((opt, idx) => (
                <option key={idx} value={opt}>{opt}</option>
              ))}
            </select>

            <div style={{ marginBottom: '10px' }}>
              <label>Add button or list to your response</label>
              <select
                style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                onChange={() => setShowListModal(true)}
              >
                <option value="">None</option>
                <option value="button">Button</option>
                <option value="list">List</option>
              </select>
            </div>

            <label>Select a trait</label>
            <select
              value={resp.trait}
              onChange={(e) => handleSaveResponse(i, 'trait', e.target.value)}
              style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
            >
              <option value="">Select a trait</option>
              {traitOptions.map((t, idx) => <option key={idx} value={t}>{t}</option>)}
            </select>

            <button style={{ width: '100%', backgroundColor: '#00b386', color: 'white', padding: '10px', border: 'none', borderRadius: '5px' }}>
              Save
            </button>
          </div>
        ))}
        <div
          onClick={handleAddResponse}
          style={{ color: '#00b386', cursor: 'pointer', fontWeight: 'bold' }}
        >
          + Add another response
        </div>
      </div>

      {/* Modal for List Selection */}
      {showListModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          background: 'rgba(0,0,0,0.4)', display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
          <div style={{ width: '600px', background: '#fff', padding: '20px', borderRadius: '10px' }}>
            <h3>Select a List</h3>
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {lists.map((list, idx) => (
                <div
                  key={idx}
                  style={{
                    border: '1px solid #ddd', padding: '10px', marginBottom: '10px',
                    backgroundColor: activeList?.name === list.name ? '#e0f2f1' : '#fff',
                    cursor: 'pointer'
                  }}
                  onClick={() => handleSelectList(list)}
                >
                  <strong>{list.name}</strong>
                  {activeList?.name === list.name && (
                    <div style={{ marginTop: '10px' }}>
                      <input defaultValue={list.name} style={{ marginBottom: '10px' }} />
                      <input defaultValue="View List" />
                      <p>Inputs:</p>
                      <ul>
                        {list.items.map((it, i) => <li key={i}>{it}</li>)}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <button
              onClick={() => confirmSelectList(0)}
              style={{ backgroundColor: '#00b386', color: '#fff', padding: '10px 20px', marginTop: '10px', border: 'none' }}
            >
              Select
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateWorkflowPage;
